import {keys} from "../config/nameSpacesKeys";
import {assetKeys} from "../config/constants";
import GenericLangValue from "./GenericLangValue";
import GenericIdValue from "./GenericIdValue";
import GenericIdValueList from "./GenericIdValueList";

export default class MsLanguageValueObj {
  constructor(name, initialValue, namespace, languageCodeNameSpace, languageVarietyNameNameSpace, regionNameSpace, scriptNameSpace, variantNameSpace) {
    this.namespace = namespace;
    this.name = name;
    this.languageCodeNameSpace = languageCodeNameSpace;
    this.languageVarietyNameNameSpace = languageVarietyNameNameSpace;
    this.regionNameSpace = regionNameSpace;
    this.scriptNameSpace = scriptNameSpace;
    this.variantNameSpace = variantNameSpace;
    this.languageVarietyName = new GenericLangValue("languageVarietyName", null, languageVarietyNameNameSpace);
    this.languageCode = new GenericIdValue("languageCode", null, languageCodeNameSpace);
    this.region = new GenericIdValue("region", null, regionNameSpace);
    this.script = new GenericIdValue("script", null, scriptNameSpace);
    this.variant = new GenericIdValueList("variant", null, variantNameSpace);
    if (initialValue) {
      this.parseInputJSON(initialValue);
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getLanguageVarietyNameObj() {
    return this.languageVarietyName;
  }

  setLanguageVarietyNameObj(languageVarietyNameObj) {
    this.languageVarietyName = languageVarietyNameObj;
  }

  getLanguageCodeObj() {
    return this.languageCode;
  }

  setLanguageCodeObj(languageCodeObj) {
    this.languageCode = languageCodeObj;
  }

  getRegionObj() {
    return this.region;
  }

  setRegionObj(regionObj) {
    this.region = regionObj;
  }

  getScriptObj() {
    return this.script;
  }

  setScriptObj(scriptObj) {
    this.script = scriptObj;
  }

  setVariantObj(variantObj) {
    this.variant = variantObj;
  }

  getVariantObj() {
    return this.variant;
  }

  setValueObj(obj) {
    this.languageVarietyName.parseInputJSON(obj);
    this.languageCode.parseInputJSON(obj);
    this.region.parseInputJSON(obj);
    this.script.parseInputJSON(obj);
    this.variant.parseInputJSON(obj);
  }

  getExpandedFormatValue() {
    const obj = {};
    const languageVarietyNameExpanded = this.languageVarietyName.getExpandedFormatValue();
    const languageCodeExpanded = this.languageCode.getExpandedFormatValue();
    const regionExpanded = this.region.getExpandedFormatValue();
    const scriptExpanded = this.script.getExpandedFormatValue();
    const variantExpanded = this.variant.getExpandedFormatValue();

    obj[assetKeys.type] = [`${keys.msLanguage}`]; // HERE WE USE CAPITAL L
    obj[this.languageVarietyName.getNameSpace()] = languageVarietyNameExpanded;
    obj[this.languageCode.getNameSpace()] = languageCodeExpanded;
    obj[this.region.getNameSpace()] = regionExpanded;
    obj[this.script.getNameSpace()] = scriptExpanded;
    obj[this.variant.getNameSpace()] = variantExpanded;
    return obj;
  }

  parseInputJSON(inputJSON) {
    const obj = inputJSON; // inputJSON[this.namespace];
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        this.setValueObj(value);
      }
    } else {
      this.setValueObj(obj);
    }
  }

  isEmpty() {
    const condition1 = this.languageVarietyName.isEmpty() && this.languageCode.isEmpty() && this.region.isEmpty() && this.script.isEmpty() && this.variant.isEmpty();
    return condition1;
  }
}
